// extracted by mini-css-extract-plugin
export default {"loginHistory":"LoginHistory-module--loginHistory--c0a00"};